export default {"src":"/_next/static/media/placeholder-prize-badge.f0c21222.svg","height":222,"width":222,"blurWidth":0,"blurHeight":0};